import React from "react"
import Cookies from "universal-cookie"

export default class Logout extends React.Component {
  componentDidMount() {
    console.log("remove cookie")

    let cookies = new Cookies()

    console.log("cookie bg_token", cookies.get("bg_token"))
    console.log("cookie bg_user", cookies.get("bg_user"))
    console.log("cookie bg_refresh_token", cookies.get("bg_refresh_token"))

    cookies.remove("bg_user", { path: "/" })
    cookies.remove("bg_token", { path: "/" })
    cookies.remove("bg_refresh_token", { path: "/" })
    cookies.remove("bg_time_offset", { path: "/" })
    window.location = "/admin"
  }

  render() {
    return "LOGOUT PAGE"
  }
}
